import rowBlockMeta from './block.json';
import rowIcon from './icon';
import attributeVisibility from '@components/visibility/attributes.json';
import attributeClassDropDown from '@components/class-dropdown/attributes.json';
import { getBlockLabelByName } from '@helpers/utils';
import edit from './edit';
import save from './save';
import './style.scss';

const { registerBlockType } = wp.blocks;
const { name, ...settings } = rowBlockMeta;

const attributes = {
  ...settings.attributes,
  ...attributeVisibility,
  ...attributeClassDropDown,
};

registerBlockType(name, {
  ...settings,
  icon: rowIcon,
  attributes,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
